<input class="{{ innerClass }}"
       [ngClass]="{ 'datepicker-invisible': hideInput}"
       #dp="bsDaterangepicker"
       bsDaterangepicker
       (ngModelChange)="changeDate($event)"
       [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-default', showWeekNumbers: false }"
       [(ngModel)]="date">